// Misc
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';

// Atoms
import Link, { LinkButton } from 'atoms/Link';
import Container from 'atoms/Container';
import Typography from 'material-ui/Typography';
import ButtonBase from 'material-ui/ButtonBase';
import Grid from 'material-ui/Grid';
import Svg from 'atoms/Svg';
// import Parallax from 'atoms/Parallax';

// Components
import Helmet from 'components/Helmet';
import Header from 'components/Header';
import FooterMenu from 'components/Footer/Menu';

// Icons
import smartPhoneSymbol from 'assets/icons/smartphone.svg';
import creditCardSymbol from 'assets/icons/credit-card.svg';
import zapSymbol from 'assets/icons/zap.svg';
import userSymbol from 'assets/icons/user.svg';
import calendarSymbol from 'assets/icons/calendar.svg';
import monitorSymbol from 'assets/icons/monitor.svg';

// Styles
import styles from './styles';

const features = [
  {
    icon: smartPhoneSymbol,
    accentColor: '#6BFCC1',
    title: 'Seamless bookings',
    description: 'Let your students search, book and pay in a few taps through a simple and powerful app',
    withLink: true
  },
  {
    icon: creditCardSymbol,
    accentColor: '#6E40DD',
    title: 'Universal payments',
    description: 'Accept Alipay, WeChat Pay, Apple Pay and any major card in 130+ currencies'
  },
  {
    icon: zapSymbol,
    accentColor: '#EFEF30',
    title: 'Fast payouts',
    description: 'Improve cashflow with fast and reliable payouts. No more chasing cheques or unpaid invoices'
  },
  {
    icon: userSymbol,
    accentColor: '#00657F',
    title: 'Admin controls',
    description: 'Manage everything in one\r\nplace – your students, your tutors and their availability, calendars, payments and more',
    withLink: true
  },
  {
    icon: calendarSymbol,
    accentColor: '#92E4FC',
    title: 'Advanced scheduling',
    description: 'Rely on our system to handle complex schedules with incredible ease. No need to set reminders as everyone is always up-to-date and in sync'
  },
  {
    icon: monitorSymbol,
    accentColor: '#BCA8FC',
    title: 'Virtual classrooms',
    description: 'A cutting-edge platform for your students and tutors to connect face to face with a powerful whiteboard and\r\nultra-fast file sharing',
    withLink: true
  }
];

@withStyles(styles)
export default class HomePage extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Helmet />
        <Header />

        <div className={classes.mainSection}>
          <Container>
            <div className={classes.mainSectionText}>
              <Typography className={classes.mainSectionTextTitle}>
                Your tutoring business online{'\r\n'}and mobile in minutes
              </Typography>
              <Typography className={classes.mainSectionTextDescription}>
                Tewtor is the best platform for running a tutoring
                {'\r\n'}business and supercharging student engagement.
              </Typography>
              <LinkButton to="https://indemandly.com/register" external raised color="primary">
                Sign up for free
              </LinkButton>
            </div>
          </Container>
          <div className={classes.mainSectionMacbook}>
            <div className={classes.mainSectionIphone} />
          </div>
        </div>

        <div className={classes.purpleStripe}>
          <div className={classes.purpleStripeInner}>
            <div className={classes.purpleStripeText}>
              <Container className={classes.purpleStripeContainer}>
                <Typography className={classes.purpleStripeTextTitle}>
                  Take your tutoring business &{'\r\n'}profitability to the next level
                </Typography>
                <Typography className={classes.purpleStripeTextDescription}>
                  Tewtor streamlines calendars, scheduling and payments in a simple,
                  end to end solution for your students, tutors and admin staff.
                  Improve visibility, student satisfaction, communication, time management and
                  gain critical insights into your tutoring school business.
                </Typography>
                <ButtonBase
                  className={classes.purpleStripeTextButton}
                  component={Link}
                  to="/features"
                >
                  Learn more
                </ButtonBase>
              </Container>
            </div>
            <div className={classes.purpleStripeImage}>
              <Container className={classes.purpleStripeContainer}>
                <div className={classes.purpleStripeImageInner} />
              </Container>
            </div>
          </div>
        </div>

        <Container>
          <div className={classes.features}>
            <Typography className={classes.featuresTitle}>
              A complete toolkit for your students, your{'\r\n'}tutors, and your business.
            </Typography>
            <Grid
              container
              spacing={40}
              alignItems="stretch"
              justify="space-around"
            >
              { features.map(feature => (
                <Grid
                  key={feature.title}
                  item
                  lg={4}
                  sm={6}
                  xs={12}
                >
                  <div className={classes.feature}>
                    <div className={classes.featureIcon}>
                      <Svg
                        symbol={feature.icon}
                        stroke={feature.accentColor}
                        fill="#fff"
                      />
                    </div>
                    <Typography className={classes.featureTitle}>
                      { feature.title }
                    </Typography>
                    <Typography className={classes.featureDescription}>
                      { feature.description }
                    </Typography>
                    { !!feature.withLink &&
                      <div className={classes.featureLink}>
                        <Link to="/features" style={{ color: feature.accentColor }}>
                          Learn more →
                        </Link>
                      </div>
                    }
                  </div>
                </Grid>
              )) }
            </Grid>
          </div>
        </Container>

        <div className={classes.footer}>
          <Container>
            <Typography className={classes.footerTitle}>
              Trusted by tutoring schools everywhere
            </Typography>
            <Typography className={classes.footerDescription}>
              From fast-growing tutoring businesses with students all{'\r\n'}
              over the world to private tutors working with a few regulars, users love Tewtor.
            </Typography>
            <ButtonBase
              className={classes.footerButton}
              component={Link}
              to="https://indemandly.com/register" external 
            >
              Sign up for free
            </ButtonBase>
            <div className={classes.footerMenu}>
              <FooterMenu />
            </div>
          </Container>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/index.js